// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.black-color {
  color: #1A1A18;
}

.header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 10px 0px;
  background: transparent;
  height: calc(100% - 80px);
  padding: 30px 20px;
  text-transform: uppercase;
}
.header .icon_wrapper ion-icon {
  height: 10px;
  width: 10px;
  rotate: 180deg;
  transition: rotate 0.5s;
  margin-left: 10px;
}
.header .icon_wrapper ion-icon.isOpen {
  rotate: 0deg;
}

.title {
  cursor: pointer;
  position: relative;
  margin: 0;
  text-transform: none;
  font-family: AppFontMedium, sans-serif;
  font-size: 16px;
  line-height: 16px;
  text-align: left;
  color: var(--ion-color-black);
}

.name {
  font-family: AppFontMedium, sans-serif;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.01em;
  color: var(--ion-color-black);
  text-align: left;
  text-transform: none;
  padding: 15px 0px;
}

p {
  padding: 15px 0px;
  text-align: left;
  font-family: AppFont, sans-serif;
  font-size: 11.5px;
  line-height: 20px;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  color: var(--ion-color-black) !important;
}

div {
  position: relative;
  transition: max-height linear 0.3s;
}
.active {
  max-height: -moz-fit-content;
  max-height: fit-content;
  overflow: auto;
  width: 100%;
  padding-top: 10px;
}

.inactive {
  max-height: 0;
  overflow: hidden;
}

.nutrition-name {
  font-size: 10px;
  text-align: left;
  color: var(--ion-color-black);
  text-transform: none;
  padding-left: 20px;
}

.nutrition-value {
  text-align: right;
  color: var(--ion-color-black);
  text-transform: none;
  font-size: 10px;
  padding-right: 20px;
}

.border-top {
  border-top: 1px solid var(--ion-color-grey);
}

.allergens_title {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  color: var(--ion-color-black);
  text-transform: uppercase;
}

ul {
  margin: 0px;
  padding: 0px 30px;
}
ul li {
  font-size: 10px;
  text-align: left;
  color: var(--ion-color-black) !important;
  text-transform: none;
  padding: 6px 0px;
}

.padding-top {
  padding-top: 15px;
}

.button {
  width: 100%;
  padding: 20px;
  border-top: 1px solid var(--color-black);
  margin-top: 20px;
}
.button .close {
  background: #ebdfda;
  text-align: center;
  border-radius: 26px;
  cursor: pointer;
}
.button .close:hover {
  background: #f2dbd9;
}
.button .close p {
  text-align: center;
  font-size: 16px;
  padding: 10px;
  font-family: AppFontMedium, sans-serif;
  color: var(--color-black) !important;
  text-transform: uppercase;
}

.cross-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 25px;
  height: 25px;
  z-index: 99;
  margin: 0px;
  background: var(--color-white-accent);
  width: 22px;
  height: 22px;
  padding: 0px;
  z-index: 99;
}
.cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.cross-icon:hover {
  background: #f2dbd9;
}

ul {
  margin: 0px;
  list-style-type: none;
  padding: 0;
}

.eintracht-modal {
  background: #282828;
}
.eintracht-modal .title, .eintracht-modal .name, .eintracht-modal p, .eintracht-modal .nutrition-name, .eintracht-modal .nutrition-value, .eintracht-modal .allergens_title, .eintracht-modal ul li {
  color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/allergens-info-modal/allergens-info-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AAAF;AAMA;EACE,cAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAJF;AAOK;EACG,YAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AALR;AAMQ;EACG,YAAA;AAJX;;AAUA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EAEA,oBAAA;EAEA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,6BAAA;AAVF;;AAaA;EACE,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAEA,gBAAA;EACA,oBAAA;EAEA,iBAAA;AAZF;;AAeA;EACE,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,wCAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,kCAAA;AAbF;AAsBA;EACE,4BAAA;EAAA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,gBAAA;AApBF;;AAsBA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,oBAAA;EAEA,kBAAA;AApBF;;AAsBA;EACE,iBAAA;EACA,6BAAA;EAEA,oBAAA;EAEA,eAAA;EACA,mBAAA;AArBF;;AAuBA;EACE,2CAAA;AApBF;;AAsBA;EACE,gCAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;AAnBF;;AAsBA;EACE,WAAA;EAEA,iBAAA;AApBF;AAqBE;EACG,eAAA;EACA,gBAAA;EACA,wCAAA;EAED,oBAAA;EACC,gBAAA;AApBL;;AAuBA;EACE,iBAAA;AApBF;;AAsBA;EACE,WAAA;EACA,aAAA;EACA,wCAAA;EACA,gBAAA;AAnBF;AAoBE;EAEE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAnBJ;AAoBI;EAEE,mBAAA;AAnBN;AAqBI;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sCAAA;EACA,oCAAA;EACA,yBAAA;AAnBN;;AAwBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAtBF;AAuBE;EACI,WAAA;EACA,YAAA;EACA,WAAA;AArBN;AAuBE;EACI,mBAAA;AArBN;;AAyBA;EACI,WAAA;EACA,qBAAA;EACA,UAAA;AAtBJ;;AAwBA;EACI,mBAAA;AArBJ;AAsBI;EACI,sBAAA;AApBR","sourcesContent":[".container {\n  width: 100%;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  // background: #EAEAEB;\n  &.activated {\n     // background: white;\n  }\n}\n.black-color {\n  color: #1A1A18;\n\n}\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  padding: 10px 0px;\n  background: transparent;\n  height: calc(100% - 80px);\n  padding: 30px 20px;\n  text-transform: uppercase;\n\n  .icon_wrapper {\n     ion-icon {\n        height: 10px;\n        width: 10px;\n        rotate: 180deg;\n        transition: rotate 0.5s;\n        margin-left: 10px;\n        &.isOpen{\n           rotate: 0deg;\n        }\n     }\n  }\n}\n\n.title {\n  cursor: pointer;\n  position: relative;\n  margin: 0;\n\n  text-transform: none;\n\n  font-family: AppFontMedium, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n  text-align: left;\n\n  color: var(--ion-color-black);\n}\n\n.name {\n  font-family: AppFontMedium, sans-serif;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: 0.01em;\n  color: var(--ion-color-black);\n\n  text-align: left;\n  text-transform: none;\n\n  padding: 15px 0px;\n}\n\np {\n  padding: 15px 0px;\n  text-align: left;\n  font-family: AppFont, sans-serif;\n  font-size: 11.5px;\n  line-height: 20px;\n  letter-spacing: 0.01em;\n  text-transform: uppercase;\n\n  color: var(--ion-color-black) !important;\n}\n\ndiv {\n  position: relative;\n  transition: max-height linear 0.3s;\n\n  ion-button {\n\n\n\n  }\n}\n\n.active {\n  max-height: fit-content;\n  overflow: auto;\n  width: 100%;\n  padding-top: 10px;\n}\n\n.inactive {\n  max-height: 0;\n  overflow: hidden;\n}\n.nutrition-name {\n  font-size: 10px;\n  text-align: left;\n  color: var(--ion-color-black);\n  text-transform: none;\n\n  padding-left: 20px;\n}\n.nutrition-value {\n  text-align: right;\n  color: var(--ion-color-black);\n\n  text-transform: none;\n\n  font-size: 10px;\n  padding-right: 20px;\n}\n.border-top {\n  border-top: 1px solid var(--ion-color-grey);\n}\n.allergens_title {\n  font-family: AppFont, sans-serif;\n  font-size: 16px;\n  color: var(--ion-color-black);\n  text-transform: uppercase;\n\n}\nul {\n  margin: 0px;\n  // list-style-type: none;\n  padding: 0px 30px;\n  li {\n     font-size: 10px;\n     text-align: left;\n     color: var(--ion-color-black)     !important;\n\n    text-transform: none;\n     padding: 6px 0px;\n  }\n}\n.padding-top {\n  padding-top: 15px;\n}\n.button {\n  width: 100%;\n  padding: 20px;\n  border-top: 1px solid var(--color-black);\n  margin-top: 20px;\n  .close {\n\n    background: #ebdfda;\n    text-align: center;\n    border-radius: 26px;\n    cursor: pointer;\n    &:hover {\n\n      background: #f2dbd9;\n    }\n    p {\n      text-align: center;\n      font-size: 16px;\n      padding: 10px;\n      font-family: AppFontMedium, sans-serif;\n      color: var(--color-black) !important;\n      text-transform: uppercase;\n\n    }\n  }\n}\n.cross-icon {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  width: 25px;\n  height: 25px;\n  z-index: 99;\n\n  margin: 0px;\n  background: var(--color-white-accent);\n  width: 22px;\n  height: 22px;\n  padding: 0px;\n  z-index: 99;\n  ion-icon {\n      width: 100%;\n      height: 100%;\n      margin: 0px;\n  }\n  &:hover {\n      background: #f2dbd9;\n  }\n}\n\nul {\n    margin: 0px;\n    list-style-type: none;\n    padding: 0;\n}\n.eintracht-modal {\n    background: #282828;\n    .title, .name, p, .nutrition-name, .nutrition-value, .allergens_title, ul li {\n        color: #fff !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
